import React, { useEffect } from 'react';
import { Header } from '../dealflow/Header';
import { CalculatorHero } from './sections/CalculatorHero';
import { WhyMetaAdsSection } from './sections/WhyMetaAdsSection';
import { TraditionalDealSourceSection } from './sections/TraditionalDealSourceSection';
import { CalculatorValueSection } from './sections/CalculatorValueSection';
import { FinalCTASection } from './sections/FinalCTASection';
import { Footer } from '../dealflow/Footer';
import { CalculatorForm } from './CalculatorForm';
export function CalculatorPage() {
  // Set up animations
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    });
    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    animatedElements.forEach(el => observer.observe(el));
    // Add scroll to form functionality for CTA buttons
    const scrollToFormButtons = document.querySelectorAll('.scroll-to-form');
    scrollToFormButtons.forEach(button => {
      button.addEventListener('click', e => {
        e.preventDefault();
        const form = document.getElementById('calculator-form');
        if (form) {
          form.scrollIntoView({
            behavior: 'smooth'
          });
        }
      });
    });
    return () => {
      animatedElements.forEach(el => observer.unobserve(el));
      scrollToFormButtons.forEach(button => {
        button.removeEventListener('click', () => {});
      });
    };
  }, []);
  return <div className="w-full min-h-full bg-white text-black" data-id="element-66">
      <div className="bg-dark-900" data-id="element-67">
        <Header data-id="element-68" />
      </div>
      <CalculatorHero data-id="element-69" />
      {/* Desktop two-column layout */}
      <div className="hidden lg:block max-w-6xl mx-auto px-4 md:px-6 lg:px-8 mb-12" data-id="element-70">
        <div className="flex flex-row gap-8" data-id="element-71">
          {/* Left column: Form */}
          <div className="w-1/2" data-id="element-72">
            <div className="bg-white rounded-xl p-0" id="calculator-form" data-id="element-73">
              <h3 className="text-[20px] font-bold text-black mb-4 text-center" data-id="element-74">
                Get The Interactive Deal Flow Cost Calculator
              </h3>
              <CalculatorForm data-id="element-75" />
            </div>
          </div>
          {/* Right column: Why Meta Ads */}
          <div className="w-1/2" data-id="element-76">
            <WhyMetaAdsSection data-id="element-77" />
          </div>
        </div>
      </div>
      {/* Mobile layout (unchanged) */}
      <div className="lg:hidden max-w-[800px] mx-auto px-4 py-12" data-id="element-78">
        <WhyMetaAdsSection data-id="element-79" />
        <TraditionalDealSourceSection data-id="element-80" />
        <CalculatorValueSection data-id="element-81" />
      </div>
      {/* Desktop continued sections */}
      <div className="hidden lg:block max-w-[800px] mx-auto px-4 py-12" data-id="element-82">
        <TraditionalDealSourceSection data-id="element-83" />
        <CalculatorValueSection data-id="element-84" />
      </div>
      <FinalCTASection data-id="element-85" />
      <Footer data-id="element-86" />
    </div>;
}